module.exports = require('./base')



//////////////////
// WEBPACK FOOTER
// ./node_modules/typewise/index.js
// module id = +rRf
// module chunks = 70